module.exports = __webpack_public_path__ + "img/text_record.3c89de4d.png";